import getApiClient from '@/plugins/api'

export default {
  loadProducts: function() {
    const self = this,
      api = getApiClient(self.$store)

    self.$store.commit('startLoading')
    api.get('boost_products')
      .then(response => {
        self.products = response.data['hydra:member']
      })
      .catch(() => {})
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
